import { createSlice } from '@reduxjs/toolkit';

let initialState = {
    data: {payload: {login: false}}
};


export const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    setLogin: (state,data) => {
        state.data = data;
    }
}
})

export const { setLogin } = loginSlice.actions;

export default loginSlice.reducer;